import {useEffect, useRef} from "react";
import {driver, DriverHook, DriveStep} from "driver.js";
import "driver.js/dist/driver.css";
import {getPageUrlForFlow, tutorialFlows1 as tutorialFlows, TutorialStep} from "./tutorialFlows1";
import {useNavigate, useLocation} from "react-router-dom";
import './index.css';
import "./CommonStaticDialog.css";

export const AppTutorialManager1 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const tutorialAnimations = new Set<HTMLElement>();
    const sonarWrappers = new Set<HTMLElement>();
    const currentStepRef = useRef<number>(-1);
    const activeDriverRef = useRef<any>(null);
    const flowStartTokenRef = useRef<number>(0);
    const eventStore = useRef<Array<{ element: EventTarget; type: string; handler: EventListener; options?: boolean | AddEventListenerOptions }>>([]);

    const clearEventStore = () => {
        eventStore.current.forEach(({element, type, handler, options}) => {
            (element as HTMLElement).removeEventListener(type, handler, options);
        });
        eventStore.current = [];
    };

    const getStyleByFlowName = () => {
        const currentState = JSON.parse(localStorage.getItem("tutorialProgress") ?? "{}");
        const flowName = currentState.currentFlow ?? "";
        switch (flowName) {
            case "introFlow":
                return {
                    primaryColor: "#687543",
                    hoverBackgroundColor: "#869064",
                    guardianImage: '/assets/cyborg-bear-1.png',
                };
            case "scamIdentifyFlow1":
                return {
                    primaryColor: "#687543",
                    hoverBackgroundColor: "#869064",
                    guardianImage: '/assets/cyborg-bear-1.png',
                };
            case "scamIdentifyFlow":
                return {
                    primaryColor: "#687543",
                    hoverBackgroundColor: "#869064",
                    guardianImage: '/assets/cyborg-bear-1.png',
                };
            case "scamEducationFlow":
                return {
                    primaryColor: "#18475CFF",
                    hoverBackgroundColor: "rgb(24 71 92 / 69%)",

                };
            case "antiScamFlow":
                return {
                    primaryColor: "#553c1a",
                    hoverBackgroundColor: "#664f32f0",
                };
            case "communityFlow":
                return {
                    primaryColor: "#1c2e50",
                    hoverBackgroundColor: "#5581a0",
                };
            case "archivesFlow":
                return {
                    primaryColor: "#832f37",
                    hoverBackgroundColor: "#99444c",
                };
            default:
                return {
                    primaryColor: "#687543",
                    hoverBackgroundColor: "#869064",
                };
        }
    }
    const showStaticDialog = (options: any) => {
        const {
            title = "Title",
            content = "Content...",
            avatar = "",
            confirmText = "OK",
            cancelText = "Cancel",
            onConfirm = null,
            onCancel = null
        } = options;

        const oldDialog = document.getElementById("common-dialog-backdrop");
        if (oldDialog) oldDialog.remove();

        const wrapper = document.createElement("div");
        const style1 = `
        display: block; border-radius: 12px; font-weight: bold; font-family: Orbitron, sans-serif; box-shadow: rgba(122, 94, 59, 0.4) 0px 0px 6px; font-size: 1.15rem; cursor: pointer; transition: 0.25s; text-shadow: none;
        `
        const avatarSourceImage = `/assets/${avatar}`;
        wrapper.innerHTML = `
                    
                    <div class="common-dialog-backdrop" id="common-dialog-backdrop">
                      <div class="common-dialog">
                        
                        <div class="common-dialog-title">
                         ${avatar ? `<img class="dialog-avatar" src="${avatarSourceImage}" style="width: 64px; height: 64px; border-radius: 12px; box-shadow: rgba(122, 94, 59, 0.5) 0 0 8px; object-fit: contain;" alt=""/>` : ""}
                          <span class="dialog-title-text">${title}</span>
                        </div>
                
                        <div class="common-dialog-content">${content}</div>
                
                        <div class="common-dialog-actions">
                          <button class="dialog-btn-cancel">${cancelText}</button>
                          <button class="dialog-btn-confirm"
                          style="${style1}"
                          >${confirmText}</button>                          
                        </div>
                
                      </div>
                    </div>
                `;

        const dialogEl = wrapper.firstElementChild as HTMLElement;
        if (dialogEl) {
            dialogEl.style.position = "fixed";
            dialogEl.style.zIndex = "2147483647"; // MAX
            (dialogEl as HTMLElement).style.setProperty("z-index", "2147483647", "important");
            document.body.classList.remove("driver-active");
            document.body.classList.remove("driver-fade");
            document.body.appendChild(dialogEl);
        }

        // Actions
        const backdrop = document.getElementById("common-dialog-backdrop");
        if (backdrop) {
            const backdrop = document.getElementById("common-dialog-backdrop") as HTMLElement;
            backdrop.style.position = "fixed";
            backdrop.style.top = "0";
            backdrop.style.left = "0";
            backdrop.style.setProperty("z-index", "2147483647", "important");
            const styleObject = getStyleByFlowName();

            const btnCancel = backdrop.querySelector(".dialog-btn-cancel") as HTMLButtonElement | null;
            if (btnCancel) {
                Object.assign(btnCancel!.style, {
                    borderRadius: "12px",
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "rgba(255,255,255,0.6)",
                    color: styleObject.primaryColor,
                    boxShadow: "0 0 6px rgba(122, 94, 59, 0.4)",
                    fontSize: {lg: '1.15rem', md: "0.875rem"},
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    textShadow: "none",
                    position: "relative",
                });
                btnCancel.addEventListener("mouseenter", () => {
                    btnCancel.style.backgroundColor = styleObject.hoverBackgroundColor;
                    btnCancel.style.color = "white";
                    btnCancel.style.boxShadow = "0 0 12px #7a5e3b";
                });
                btnCancel.addEventListener("mouseleave", () => {
                    btnCancel.style.backgroundColor = "rgba(255,255,255,0.6)";
                    btnCancel.style.color = styleObject.primaryColor;
                    btnCancel.style.boxShadow = "0 0 6px rgba(122, 94, 59, 0.4)";
                });
            }
            const btnConfirm = backdrop.querySelector(".dialog-btn-confirm") as HTMLButtonElement | null;
            if (btnConfirm) {
                Object.assign(btnConfirm!.style, {
                    borderRadius: "12px",
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "rgba(255,255,255,0.6)",
                    color: styleObject.primaryColor,
                    boxShadow: "0 0 6px rgba(122, 94, 59, 0.4)",
                    fontSize: {lg: '1.15rem', md: "0.875rem"},
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    textShadow: "none",
                    position: "relative",
                });
                btnConfirm.addEventListener("mouseenter", () => {
                    btnConfirm.style.backgroundColor = styleObject.hoverBackgroundColor;
                    btnConfirm.style.color = "white";
                    btnConfirm.style.boxShadow = "0 0 12px #7a5e3b";
                });
                btnConfirm.addEventListener("mouseleave", () => {
                    btnConfirm.style.backgroundColor = "rgba(255,255,255,0.6)";
                    btnConfirm.style.color = styleObject.primaryColor;
                    btnConfirm.style.boxShadow = "0 0 6px rgba(122, 94, 59, 0.4)";
                });
            }


            if (btnCancel)
                btnCancel.onclick = () => {
                    document.body.classList.add("driver-fade");
                    document.body.classList.add("driver-active");
                    backdrop.remove();
                    onCancel && onCancel();
                };

            if (btnConfirm)
                btnConfirm.onclick = () => {
                    backdrop.remove();
                    onConfirm && onConfirm();
                };
        }
    }

    useEffect(() => {
        const hasDone = localStorage.getItem("hasCompletedTutorial");
        if (hasDone) return;

        const flowChain = [
            "introFlow",
            "scamIdentifyFlow1",
            "scamIdentifyFlow",
            "scamEducationFlow",
            "antiScamFlow",
            "communityFlow",
            "archivesFlow",
        ];

        const getNextFlow = (flowName: string) => {
            const idx = flowChain.indexOf(flowName);
            return idx >= 0 && idx < flowChain.length - 1 ? flowChain[idx + 1] : null;
        };

        const getPrevFlow = (flowName: string) => {
            const idx = flowChain.indexOf(flowName);
            return idx > 0 ? flowChain[idx - 1] : null;
        };

        const handleNextClick = async (driverInstance: any, flowName: string, steps: any[], waitForElement: any) => {
            const state = driverInstance.getState();
            const isLastStep = state.activeIndex === steps.length - 1;

            // ⭐ Nếu là bước cuối
            if (isLastStep) {

                const nextFlow = getNextFlow(flowName);

                if (nextFlow) {
                    // ⭐ Chuyển sang flow tiếp theo
                    localStorage.setItem(
                        "tutorialProgress",
                        JSON.stringify({currentFlow: nextFlow, currentStep: 0})
                    );
                    currentStepRef.current = -1;
                    console.log('currentStepRef.current', currentStepRef.current);

                    driverInstance.destroy();
                    navigate(getPageUrlForFlow(nextFlow));
                } else {
                    // ⭐ Đây là flow cuối cùng → kết thúc tutorial
                    localStorage.setItem("hasCompletedTutorial", "true");
                    currentStepRef.current = -1;
                    driverInstance.destroy();
                }

                return; // ⭐ QUAN TRỌNG: không chạy xuống dưới nữa
            }


            // ⭐ Xử lý bước bình thường
            const nextIndex = state.activeIndex + 1;
            const nextStep = steps[nextIndex];

            // Nếu bước tiếp theo có selector → chờ element xuất hiện
            if (nextStep?.selector) {
                // waitForElement(nextStep.selector, 1000).finally(() => {
                //     driverInstance.moveNext();
                // });
                const el = await waitForElement(nextStep.selector, 1500);
                if (!el) {
                    console.warn("Step skipped because element not found:", nextStep.selector);
                }
                if (flowName === 'scamIdentifyFlow') {
                    if (nextIndex !== currentStepRef.current) {
                        driverInstance.moveNext();
                        currentStepRef.current = nextIndex;
                        console.log('currentStepRef.current', currentStepRef.current);
                    }
                } else {
                    driverInstance.moveNext();
                    currentStepRef.current = nextIndex;
                    console.log('currentStepRef.current', currentStepRef.current);
                }

            } else {
                if (flowName === 'scamIdentifyFlow') {
                    if (nextIndex !== currentStepRef.current) {
                        driverInstance.moveNext();
                        currentStepRef.current = nextIndex;
                        console.log('currentStepRef.current', currentStepRef.current);
                    }
                } else {
                    driverInstance.moveNext();
                    currentStepRef.current = nextIndex;
                    console.log('currentStepRef.current', currentStepRef.current);
                }
            }
        };

        const savedProgress = JSON.parse(localStorage.getItem("tutorialProgress") || "{}");
        const currentFlow = savedProgress.currentFlow || flowChain[0];
        const currentStep = savedProgress.currentStep || 0;

        const startFlow = (flowName: string, startIndex = 0) => {
            const steps = tutorialFlows[flowName];

            if (!steps) return;

            const startToken = ++flowStartTokenRef.current;
            clearEventStore();
            if (activeDriverRef.current?.destroy) {
                activeDriverRef.current.destroy();
            }

            const driverInstance = driver({
                animate: true,
                overlayOpacity: 0.6,
                overlayColor: "rgba(0,0,0,0.75)",
                allowClose: false,
                disableActiveInteraction: false,
                stagePadding: 8,
                stageRadius: 10,
                showProgress: false,
                smoothScroll: true,
                progressText: "{{current}} / {20}",
                showButtons: ["next", "previous"],

                onDestroyed: () => {
                    const skipBtn = document.querySelector(".tutorial-skip-btn");
                    if (skipBtn) skipBtn.remove();
                    clearEventStore();
                    if (activeDriverRef.current === driverInstance) {
                        activeDriverRef.current = null;
                    }
                },

                onPopoverRender: (popover) => {
                    const state = driverInstance.getState();

                    Object.assign(popover.wrapper.style, {
                        background: "rgba(255,255,255,0.9)",
                        border: "2px solid #7a5e3b",
                        borderRadius: "12px",
                        fontFamily: '"Orbitron", sans-serif',
                        color: "#414335",
                        padding: "16px",
                        maxWidth: "560px",
                        visibility: steps[state.activeIndex].hidePopover ? "hidden" : "visible",
                    });

                    const styleObject = getStyleByFlowName();
                    const title = popover.wrapper.querySelector("#driver-popover-title") as HTMLElement;
                    if (title) {
                        Object.assign(title.style, {
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            color: styleObject.primaryColor,
                            letterSpacing: "1px",
                            fontSize: {lg: '1.4rem', md: "0.875rem"},
                        });
                    }

                    const content = popover.wrapper.querySelector("#cyborg-popover-content") as HTMLElement;
                    if (content) {
                        Object.assign(content.style, {
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                        });
                    }

                    const imageBox = popover.wrapper.querySelector("#cyborg-image-box img") as HTMLImageElement;
                    if (imageBox) {
                        Object.assign(imageBox.style, {
                            width: "64px",
                            height: "64px",
                            borderRadius: "12px",
                            boxShadow: "0 0 8px rgba(122, 94, 59, 0.5)",
                            objectFit: "contain",
                        });
                    }

                    const textBox = popover.wrapper.querySelector("#cyborg-text-box") as HTMLElement;
                    if (textBox) {
                        Object.assign(textBox.style, {
                            lineHeight: 1.43,
                            color: "#414335",
                            fontWeight: 700,
                            fontSize: '1.125rem',
                        });
                    }

                    const progressTextBox = popover.wrapper.querySelector(".driver-popover-progress-text") as HTMLElement;
                    if (progressTextBox) {
                        Object.assign(progressTextBox.style, {
                            lineHeight: 1.43,
                            color: "#414335",
                            fontWeight: 700,
                            fontSize: '1.125rem',
                        });
                    }


                    const nextBtn = popover.wrapper.querySelector(".driver-popover-next-btn") as HTMLElement;
                    const isMustClick = popover.wrapper.querySelector("#is-must-click") as HTMLElement;
                    const isMustClickWithNoAction = popover.wrapper.querySelector("#isMustClickWithNoAction") as HTMLElement;
                    const isEndStepElement = popover.wrapper.querySelector("#is-end-step") as HTMLElement;
                    const isEndStep = isEndStepElement.innerText.toLowerCase() === 'true';
                    const isMustClickBool = isMustClick && isMustClick.innerText === 'is-must-click';
                    const isMustClickWithNoActionBool = isMustClickWithNoAction && isMustClickWithNoAction.innerText === 'isMustClickWithNoAction';
                    if (nextBtn) {
                        Object.assign(nextBtn.style, {
                            borderRadius: "12px",
                            fontWeight: "bold",
                            fontFamily: '"Orbitron", sans-serif',
                            backgroundColor: "rgba(255,255,255,0.6)",
                            color: styleObject.primaryColor,
                            boxShadow: "0 0 6px rgba(122, 94, 59, 0.4)",
                            fontSize: {lg: '1.15rem', md: "0.875rem"},
                            cursor: "pointer",
                            transition: "all 0.25s ease",
                            display: isMustClickBool || isMustClickWithNoActionBool ? "none" : "block",
                            textShadow: "none",
                            position: "relative",
                        });
                        nextBtn.addEventListener("mouseenter", () => {
                            nextBtn.style.backgroundColor = styleObject.hoverBackgroundColor;
                            nextBtn.style.color = "white";
                            nextBtn.style.boxShadow = "0 0 12px #7a5e3b";
                        });
                        nextBtn.addEventListener("mouseleave", () => {
                            nextBtn.style.backgroundColor = "rgba(255,255,255,0.6)";
                            nextBtn.style.color = styleObject.primaryColor;
                            nextBtn.style.boxShadow = "0 0 6px rgba(122, 94, 59, 0.4)";
                        });
                        if (isEndStep) {
                            nextBtn.innerText = 'End of Introduction';
                            currentStepRef.current = -1;
                        }
                        const sonarWrapper = document.createElement("div");
                        sonarWrapper.className = "sonar-wrapper";
                        sonarWrapper.innerHTML = `
                                  <div class="sonar-emitter">
                                    <div class="sonar-wave sonar-wave1"></div>
                                    <div class="sonar-wave sonar-wave2"></div>
                                    <div class="sonar-wave sonar-wave3"></div>
                                    <div class="sonar-wave sonar-wave4"></div>
                                  </div>
                                `;

                        Object.assign(sonarWrapper.style, {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "30px",
                            height: "30px",
                            pointerEvents: "none",
                            zIndex: "0",
                        });
                        nextBtn.appendChild(sonarWrapper);
                        sonarWrappers.add(sonarWrapper);
                    }

                    const prevBtn = popover.wrapper.querySelector(".driver-popover-prev-btn") as any;
                    if (prevBtn) {
                        Object.assign(prevBtn.style, {
                            borderRadius: "12px",
                            fontWeight: "bold",
                            fontFamily: '"Orbitron", sans-serif',
                            backgroundColor: "rgba(255,255,255,0.6)",
                            color: styleObject.primaryColor,
                            boxShadow: "0 0 6px rgba(122, 94, 59, 0.4)",
                            fontSize: {lg: '1.15rem', md: "0.875rem"},
                            cursor: "pointer",
                            transition: "all 0.25s ease",
                            textShadow: "none",
                        });
                        prevBtn.removeAttribute("disabled");
                        prevBtn.classList.remove("driver-popover-btn-disabled");
                        prevBtn.addEventListener("mouseenter", () => {
                            prevBtn.style.backgroundColor = styleObject.hoverBackgroundColor;
                            prevBtn.style.color = "white";
                            prevBtn.style.boxShadow = "0 0 12px #7a5e3b";
                        });
                        prevBtn.addEventListener("mouseleave", () => {
                            prevBtn.style.backgroundColor = "rgba(255,255,255,0.6)";
                            prevBtn.style.color = styleObject.primaryColor;
                            prevBtn.style.boxShadow = "0 0 6px rgba(122, 94, 59, 0.4)";
                        });
                    }

                    localStorage.setItem(
                        "tutorialProgress",
                        JSON.stringify({currentFlow: flowName, currentStep: state.activeIndex})
                    );
                },

                steps: steps.map((step, index) => {

                    // const currentState = JSON.parse(localStorage.getItem("tutorialProgress") ?? "{}");
                    // const flowName = currentState.currentFlow ?? "";
                    //
                    // const state = driverInstance.getState();
                    // const isLastStepOfFlow = state.activeIndex === steps.length - 1;
                    const isEndStep = flowName === 'archivesFlow' && index === steps.length - 1;

                    const handleNextClickInternal = async () => handleNextClick(driverInstance, flowName, steps, waitForElement);

                    const handlePrevClick: DriverHook = (_element, _step) => {
                        const state = driverInstance.getState();
                        const isFirstStep = state.activeIndex === 0;

                        if (isFirstStep) {
                            const prevFlow = getPrevFlow(flowName);
                            if (prevFlow) {
                                localStorage.setItem(
                                    "tutorialProgress",
                                    JSON.stringify({
                                        currentFlow: prevFlow,
                                        currentStep: tutorialFlows[prevFlow].length - 1,
                                    })
                                );

                                driverInstance.destroy();
                                navigate(getPageUrlForFlow(prevFlow));
                                return;
                            }
                        }

                        // Nếu là introFlow step 0 → không làm gì
                        if (!getPrevFlow(flowName) && state.activeIndex === 0) {
                            return; // disable trong đúng flow đầu tiên
                        }

                        currentStepRef.current = state.activeIndex - 1;
                        console.log('currentStepRef.current', currentStepRef.current);
                        driverInstance.movePrevious();
                        sonarWrappers.forEach(sonar => sonar.remove());
                        sonarWrappers.clear();
                    };

                    const handleHighlighted: DriverHook = (_el, _step, opts) => {
                        document.querySelectorAll("[data-disabled-by-tutorial]").forEach(btn => {
                            (btn as HTMLElement).style.pointerEvents = "";
                            btn.removeAttribute("data-disabled-by-tutorial");
                        });
                        const {driver} = opts;

                        if (step.isMustClick) {
                            const btn = document.querySelector(step.selector!) as HTMLElement;
                            if (btn) {
                                const nextBtn = (driver.getState("popover") as any)?.nextButton;
                                if (nextBtn) nextBtn.disabled = true;

                                btn.querySelectorAll(".sonar-wrapper").forEach(el => el.remove());

                                const sonarWrapper = document.createElement("div");
                                sonarWrapper.className = "sonar-wrapper";
                                sonarWrapper.innerHTML = `
                                  <div class="sonar-emitter">
                                    <div class="sonar-wave sonar-wave1"></div>
                                    <div class="sonar-wave sonar-wave2"></div>
                                    <div class="sonar-wave sonar-wave3"></div>
                                    <div class="sonar-wave sonar-wave4"></div>
                                  </div>
                                `;

                                Object.assign(sonarWrapper.style, {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "30px",
                                    height: "30px",
                                    pointerEvents: "none",
                                    zIndex: "0",
                                });
                                btn.appendChild(sonarWrapper);
                                sonarWrappers.add(sonarWrapper);
                                tutorialAnimations.add(btn);

                                const onMustClick = () => {
                                    btn.removeEventListener("click", onMustClick, false);
                                    handleNextClick(driverInstance, flowName, steps, waitForElement).then(() => {
                                        sonarWrapper.remove();
                                    });
                                };
                                btn.addEventListener("click", onMustClick, false);
                                eventStore.current.push({
                                    element: btn,
                                    type: "click",
                                    handler: onMustClick,
                                    options: false,
                                });
                            }
                        } else if (step.isMustClickWithNoAction) {
                            const btn = document.querySelector(step.selector!) as HTMLElement;
                            if (btn) {
                                const nextBtn = (driver.getState("popover") as any)?.nextButton;
                                if (nextBtn) nextBtn.disabled = true;
                                btn.querySelectorAll(".sonar-wrapper").forEach(el => el.remove());

                                const sonarWrapper = document.createElement("div");
                                sonarWrapper.className = "sonar-wrapper";
                                sonarWrapper.innerHTML = `
                                      <div class="sonar-emitter">
                                        <div class="sonar-wave sonar-wave1"></div>
                                        <div class="sonar-wave sonar-wave2"></div>
                                        <div class="sonar-wave sonar-wave3"></div>
                                        <div class="sonar-wave sonar-wave4"></div>
                                      </div>
                                    `;

                                Object.assign(sonarWrapper.style, {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "30px",
                                    height: "30px",
                                    pointerEvents: "none",
                                    zIndex: "0",
                                });
                                btn.appendChild(sonarWrapper);
                                sonarWrappers.add(sonarWrapper);

                                tutorialAnimations.add(btn);

                                const blockClick = (e: MouseEvent) => {
                                    if (step.isMustClickWithNoAction) {
                                        e.stopImmediatePropagation();
                                        e.stopPropagation();
                                        e.preventDefault();
                                        btn.removeEventListener("click", blockClick as EventListener, true);

                                        handleNextClick(driverInstance, flowName, steps, waitForElement).finally(() => {
                                            sonarWrapper.remove();
                                        });
                                    }
                                };
                                btn.addEventListener("click", blockClick as EventListener, true);
                                eventStore.current.push({
                                    element: btn,
                                    type: "click",
                                    handler: blockClick as EventListener,
                                    options: true,
                                });
                            }
                        }
                        if (_el) {
                            const mustClickTarget = (step.isMustClick || step.isMustClickWithNoAction)
                                ? document.querySelector(step.selector!) as HTMLElement | null
                                : null;

                            const innerButtons = _el.querySelectorAll(
                                "button, a, [role='button'], span.MuiTouchRipple-root, button div.MuiBox-root, button div.MuiBox-root svg, button div.MuiBox-root svg path"
                            ) as NodeListOf<HTMLElement>;

                            innerButtons.forEach((btn) => {
                                if (mustClickTarget && (btn === mustClickTarget || mustClickTarget.contains(btn) || btn.contains(mustClickTarget))) {
                                    return;
                                }
                                btn.setAttribute("data-disabled-by-tutorial", "true");
                                btn.style.pointerEvents = "none";
                                btn.style.cursor = "default";
                            });

                            const unhighlight = () => {
                                innerButtons.forEach((btn) => {
                                    if (btn.getAttribute("data-disabled-by-tutorial")) {
                                        btn.style.pointerEvents = "auto";
                                        btn.style.cursor = "pointer";
                                        btn.removeAttribute("data-disabled-by-tutorial");
                                    }
                                });
                                _el.removeEventListener("driver:unhighlight", unhighlight);
                            };
                            _el.addEventListener("driver:unhighlight", unhighlight);
                        }

                        _el?.addEventListener("driver:unhighlight", () => {
                            document.querySelectorAll(".tutorial-sonar-global").forEach(el => el.remove());
                        });
                    };

                    return {
                        ...step,
                        element: step.selector,
                        popover: {
                            title: `${step.title}`,
                            description: buildDescription(step, isEndStep),
                            side: "bottom",
                            align: "center",

                            onNextClick: handleNextClickInternal,
                            onPrevClick: handlePrevClick,
                        },
                        onHighlighted: handleHighlighted,
                    } as DriveStep;
                }),
            });

            activeDriverRef.current = driverInstance;

            // async function waitForElement(selector: string, timeout = 1000): Promise<boolean> {
            //     return new Promise((resolve) => {
            //         const start = Date.now();
            //         const timer = setInterval(() => {
            //             if (document.querySelector(selector)) {
            //                 clearInterval(timer);
            //                 resolve(true);
            //             } else if (Date.now() - start > timeout) {
            //                 clearInterval(timer);
            //                 resolve(false);
            //             }
            //         }, 100);
            //     });
            // }
            function waitForElement(selector: string, timeout = 1500): Promise<Element | null> {
                return new Promise(resolve => {
                    let frameId: number;
                    const start = performance.now();

                    const check = () => {
                        const el = document.querySelector(selector);

                        if (el) {
                            cancelAnimationFrame(frameId);
                            resolve(el);
                            return;
                        }

                        if (performance.now() - start > timeout) {
                            cancelAnimationFrame(frameId);
                            resolve(null);
                            return;
                        }

                        frameId = requestAnimationFrame(check);
                    };

                    frameId = requestAnimationFrame(check);
                });
            }


            function buildDescription(step: TutorialStep, isEndStep?: boolean) {
                const srcImg = `src=${process.env.PUBLIC_URL}/assets/${step.image}`;
                const isMustClick = step.isMustClick ? "is-must-click" : "";
                const isMustClickWithNoAction = step.isMustClickWithNoAction ? "isMustClickWithNoAction" : "";

                return `
                    <div id="cyborg-popover-content">
                        <div id="is-must-click" style="display:none">${isMustClick}</div>
                        <div id="is-end-step" style="display:none">${isEndStep ? 'true' : 'false'}</div>
                        <div id="isMustClickWithNoAction" style="display:none">${isMustClickWithNoAction}</div>
                        <div id="cyborg-image-box">
                            <img ${srcImg} alt="Cyborg Bear" />
                        </div>
                        <div id="cyborg-text-box">
                            <p>${step.message}</p>
                        </div>
                    </div>`;
            }

            const handleConfirmSkip = () => {
                // Cleanup animations
                tutorialAnimations.forEach(btn => {
                    btn.getAnimations().forEach(animation => animation.cancel());
                    btn.style.boxShadow = "none";
                });
                tutorialAnimations.clear();

                // Re-enable all disabled elements
                document.querySelectorAll("[data-disabled-by-tutorial]").forEach(btn => {
                    (btn as HTMLElement).style.pointerEvents = "";
                    btn.removeAttribute("data-disabled-by-tutorial");
                    btn.getAnimations().forEach((anim: any) => anim.cancel());
                });

                sonarWrappers.forEach(sonar => sonar.remove());
                sonarWrappers.clear();
                document.querySelectorAll(".sonar-wrapper").forEach(el => el.remove());

                localStorage.setItem("hasCompletedTutorial", "true");

                // Destroy existing driver instance safely
                currentStepRef.current = -1;
                const skipBtn = document.querySelector(".tutorial-skip-btn");
                skipBtn?.remove();
                driverInstance?.destroy?.();
            };

            // 🚀 Start flow
            setTimeout(async () => {
                if (startToken !== flowStartTokenRef.current) return;
                const firstSelector = steps[startIndex]?.selector;
                if (firstSelector) await waitForElement(firstSelector, 100);
                if (startToken !== flowStartTokenRef.current) return;
                (driverInstance as any).drive(startIndex, {
                    allowPreviousOnFirstStep: true
                });
            }, 100);

            const styleObject = getStyleByFlowName();

            // 🟢 Skip Button
            let skipBtn = document.querySelector(".tutorial-skip-btn") as HTMLButtonElement;
            if (!skipBtn) {
                skipBtn = document.createElement("button");
                skipBtn.className = "tutorial-skip-btn";
                skipBtn.innerText = "Skip Introduction ✖";
                Object.assign(skipBtn.style, {
                    position: "fixed",
                    top: "82px",
                    right: "45px",
                    zIndex: "99999999",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    color: styleObject.primaryColor,
                    fontSize: {lg: '1.15rem', md: "0.875rem"},
                    cursor: "pointer",
                    pointerEvents: "auto",
                    border: 'transparent',
                    padding: '8px',
                });
                skipBtn.addEventListener("mouseenter", () => {
                    skipBtn.style.backgroundColor = styleObject.hoverBackgroundColor;
                    skipBtn.style.color = "white";
                    skipBtn.style.boxShadow = "0 0 12px #7a5e3b";
                });
                skipBtn.addEventListener("mouseleave", () => {
                    skipBtn.style.backgroundColor = "rgba(255,255,255,0.6)";
                    skipBtn.style.color = styleObject.primaryColor;
                    skipBtn.style.boxShadow = "0 0 6px rgba(122, 94, 59, 0.4)";
                });


                skipBtn.onclick = () => {
                    const currentState = JSON.parse(localStorage.getItem('tutorialProgress') as string);
                    if (currentState && currentState.currentStep === 2 && currentState.currentFlow === 'introFlow') {

                    } else {
                        const currentStep1 = tutorialFlows[currentState.currentFlow][currentState.currentStep];
                        showStaticDialog({
                            title: "Skip Introduction",
                            content: "Do you really want to skip the introduction?",
                            avatar: currentStep1.image,
                            confirmText: "Yes, skip",
                            cancelText: "Cancel",
                            onConfirm: () => {
                                handleConfirmSkip();
                                sonarWrappers.forEach(sonar => sonar.remove());
                                sonarWrappers.clear();
                            },
                        });
                    }
                }

                document.body.appendChild(skipBtn);
            }
        };

        startFlow(currentFlow, currentStep);

        return () => {
            flowStartTokenRef.current += 1;
            clearEventStore();
            if (activeDriverRef.current?.destroy) {
                activeDriverRef.current.destroy();
                activeDriverRef.current = null;
            }
        };
    }, [navigate, location]);

    return null;
};
